import {
  Question,
  Option,
  SelectedOptionsState,
  ShortAnswersState,
} from '@squareup/dex-types-shared-app-launch';
import { Box } from '@squareup/dex-ui-shared-base';
import React, { FC } from 'react';

import { RequirementQuestion } from '../requirement-question';

interface QuestionsListProps {
  questions: Question[];
  selectedOptions: SelectedOptionsState;
  shortAnswers: ShortAnswersState;
  domainName: string;
  isInitialLoadComplete: boolean;
  readOnly?: boolean;
  questionsRefs?:
    | React.MutableRefObject<Map<string, HTMLElement | null>>
    | undefined;
  onOptionSelected(option: Option, parentQuestion: Question): void;
  onShortAnswerChange(newValue: string, parentQuestion: Question): void;
}

const QuestionsList: FC<QuestionsListProps> = ({
  questions,
  selectedOptions,
  shortAnswers,
  domainName,
  isInitialLoadComplete,
  onOptionSelected,
  onShortAnswerChange,
  questionsRefs,
  readOnly = false,
}) => {
  return (
    <Box testId="requirement-questions-list">
      {questions.map((question) => {
        return (
          <RequirementQuestion
            key={question.id}
            question={question}
            shortAnswers={shortAnswers}
            domainName={domainName}
            isInitialLoadComplete={isInitialLoadComplete}
            selectedOptions={selectedOptions}
            onOptionSelected={onOptionSelected}
            onShortAnswerChange={onShortAnswerChange}
            questionsRefs={questionsRefs}
            readOnly={readOnly}
          />
        );
      })}
    </Box>
  );
};

export { type QuestionsListProps, QuestionsList };
